
import { useState,useEffect } from "react";
import viewmyresultapi from '../api/viewmyresultapi';
import loginapi from '../api/login';
import { useNavigate } from "react-router-dom";
import { APISERVERURL } from '../APIServerURL';
import Card from "../studentcomponents/SemAdmitCard";

function DownloadMyAdmitCard({accessToken,setAccessToken,setRefreshFailed,examsession}) {
  const navigate = useNavigate();   
  const [isAppLoaded,setIsAppLoaded]=useState(true);
  const [courses,setCourses]=useState([]);

  const [rollNo,setRollNo]=useState('');
  const [name,setName]=useState('');
  const [examSession,setExamSession]=useState(examsession);
  const [examSemesters,setExamSemesters]=useState([]);
  
 function setStates(data)
 {
   if(data)
   {
     setRollNo(data.studentDetails.rollno||'');
     setName(data.studentDetails.name||'');
     setExamSession(data.examSession||'');
     setExamSemesters(data.examSemesters||[]);
   }
   else{
    setRollNo('');
    setName('');
    setExamSession('');
    setExamSemesters([]);
   }
 }

  useEffect(()=>{
    const fetchAT=async ()=>{
      setIsAppLoaded(false);
     try{
                 const response= await viewmyresultapi.post('/getMyFormFillupSemesters',{session:examSession},{headers:{'Authorization':`Bearer ${accessToken}`}});    
                  //alert(JSON.stringify(response.data));
                  setStates(response.data);
               }
               catch(err)
               {
                 if( err.response.status===403)
                   {
                     navigate(`/accessdenied`); 
                   }
                 try{
                   const config = { withCredentials: true };
                   const x=await loginapi.get('/getAccessToken',config);
                   
                   const nat=x['data']['accessToken'];
                   setAccessToken(nat);
                   try{       
                     const response= await viewmyresultapi.post('/getMyFormFillupSemesters',{session:examSession},{headers:{'Authorization':`Bearer ${nat}`}});    
                               setStates(response.data);
     
                    }
                    catch(err)
                    {
                     if( err.response.status===403)
                       {
                         navigate(`/accessdenied`); 
                       }
                     alert('unusual error newposts.js');
                    }
                 }
                 catch(err)
                 {
                   alert('failed');
                 }
         
               }
               finally{
                  setIsAppLoaded(true);
               }
    }
    fetchAT();
  },[]);
  
  
  function downloadFile(fname)
  {
    fetch(`${APISERVERURL}/studentpdf/${fname}`).then((response) => {
      response.blob().then((blob) => {         
          // Creating new object of PDF file
          const fileURL =
              window.URL.createObjectURL(blob);
               
          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = fname;
          alink.click();
          setIsAppLoaded(true);
      });
    });
  }

const getAdmitCardsOfAStudent=async (e,semester)=>{
  e.preventDefault();
  try{
    //alert(img+" "+postId);
    //post request to deletePhoto wit {id,fileName}
    setIsAppLoaded(false);
    const response= await viewmyresultapi.post('/getMyAdmitCard',{semester,session:examSession},{headers:{'Authorization':`Bearer ${accessToken}`}});    
    alert(response.data);
    downloadFile(response.data);
  }
  catch(err)
  {
    if( err.response.status===403)
      {
        navigate(`/accessdenied`); 
      }
    try{
      const config = { withCredentials: true };
      const x=await loginapi.get('/getAccessToken',config);
      //alert(JSON.stringify(x['data']['accessToken']));
      
      const nat=x['data']['accessToken'];
      setAccessToken(nat);
      //console.log(`ne at ${nat}`);
      //console.log(`Second at:${accessToken}`);
      //alert('ok');
      try{       
        const response= await viewmyresultapi.post('/getMyAdmitCard',{semester,session:examSession},{headers:{'Authorization':`Bearer ${nat}`}});    
        alert(JSON.stringify(response.data));
        downloadFile(response.data);
       }
       catch(err)
       {
        if( err.response.status===403)
          {
            navigate(`/accessdenied`); 
          }
        alert('unusual error newposts.js');
        setIsAppLoaded(true);
        //alert(JSON.stringify(err));
        //navigate('/');
       }
    }
    catch(err)
    {
      alert(JSON.stringify(err));
      setIsAppLoaded(true);
      //setError(JSON.stringify(err));
      //navigate('/');
    }

  }
}
  const handleGoBack = () => {
    navigate(`/`); 
  };
   
    return (
      <main className="w-full">

        <div className="flex flex-col items-center w-full">

        <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center">DOWNLOAD ADMIT CARD</h1>
            <p className="w-full text-center text-xs text-transparent text-gray-500"> <span>...</span></p>     
          </div>

          <div className="w-full mt-4">
          {isAppLoaded ? (
            <>
            <div className="flex flex-col  w-full justify-center">

                <div className="flex flex-col w-full justify-center items-center">
                    <p className="text-gray-500 text-xs">Name:</p>
                    <p  className="text-gray-900 text-sm">{name}</p>
                </div>
            
            <div className="flex flex-col w-full justify-center items-center mt-4">
            <p className="text-gray-500 text-xs">RollNo:</p>
            <p  className="text-gray-900 text-sm">{rollNo}</p>
                </div>

                <div className="flex flex-col w-full justify-center items-center mt-4">
                <p className="text-gray-500 text-xs">Exam:</p>
                <p  className="text-gray-900 text-sm">{examSession}</p>
                </div>

                <div className="flex flex-wrap w-full justify-center items-center mt-4 gap-3">
                {examSemesters && examSemesters.length > 0 ? (
                    examSemesters.map((semester, index) => (
                    <Card key={index} data={semester} getAdmitCardsOfAStudent={getAdmitCardsOfAStudent}/>
                    ))
                ) : (
                    <div className="text-gray-500">Nothing to display</div>
                )}
                </div>
            
            </div>
            </>
          ) : (
            <p>Please wait...</p>
          )}
          </div>
        </div>

     
      </main>
    )
  }
  
  export default DownloadMyAdmitCard